import * as React from "react";

const IconLinkPlus: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="currentColor"><polygon fill="currentColor" points="5.25 .375 5.25 0 4.5 0 4.5 .375 4.5 4.5 .375 4.5 0 4.5 0 5.25 .375 5.25 4.5 5.25 4.5 9.375 4.5 9.75 5.25 9.75 5.25 9.375 5.25 5.25 9.375 5.25 9.75 5.25 9.75 4.5 9.375 4.5 5.25 4.5"  transform="translate(.375 .625)"/></svg>;
};

export default React.memo(IconLinkPlus);
